import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop
 *
 * Resets the window scroll position on every route (pathname) change so
 * navigating to a new page starts at the top instead of wherever the
 * previous page was scrolled to.
 *
 * - Runs on pathname changes only, so in-page `#hash` anchor links and
 *   query-string updates don't yank the viewport around.
 * - If the destination has a `#hash`, it scrolls that element into view
 *   instead of jumping to the top.
 * - Forces an instant jump (globals.css sets `scroll-behavior: smooth`,
 *   which would otherwise animate a long whoosh up on every navigation).
 *
 * Renders nothing. Mount once inside the Router, above <Routes>.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
